import { EditorState, Modifier } from 'wix-rich-content-editor-common';
/**
 * Simply adds the code to the editor, this will be processed
 * by the decorator then.
 */ export default function addOfficialEmote(editorState, code) {
    // Create the new entity with metadata
    const contentState = editorState.getCurrentContent();
    const selection = editorState.getSelection();
    const contentStateWithInsertedText = Modifier.replaceText(contentState, selection, `${code} `, undefined, undefined);
    const nextEditorState = EditorState.push(editorState, contentStateWithInsertedText, 'insert-official-emote');
    return nextEditorState;
}
